import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=eb06ade0&scoped=true&"
import script from "./productOrder.vue?vue&type=script&lang=js&"
export * from "./productOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06ade0",
  null
  
)

export default component.exports